import { render, staticRenderFns } from "./SSOConfig.vue?vue&type=template&id=2d5ee1bb&scoped=true&"
import script from "./SSOConfig.vue?vue&type=script&lang=js&"
export * from "./SSOConfig.vue?vue&type=script&lang=js&"
import style0 from "./SSOConfig.vue?vue&type=style&index=0&id=2d5ee1bb&prod&scoped=true&lang=css&"
import style1 from "./SSOConfig.vue?vue&type=style&index=1&id=2d5ee1bb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5ee1bb",
  null
  
)

export default component.exports